import { t } from 'i18next';
import React, { useEffect, useState } from 'react';
import { Button, Col, Figure, Form, Modal, Row, Alert } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import defaultLogo from '../../assets/images/avatar.png';
import {
  allCustomerInfos,
  saveCustomersInfo,
} from '../../pages/Customers/CustomersSlice';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { toast } from 'react-toastify';
import { resizeFile } from '../../common/uploadImage';

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const editCustomerSchema = yup.object().shape({
  name: yup.string().required('Name is a required field.'),
  phone: yup
    .string()
    .required('Phone number is a required field.')
    .min(10, 'Phone must be at least 10 numbers.')
    .matches(phoneRegExp, 'Phone number is not valid.'),
  email: yup
    .string()
    .required('Email is a required field.')
    .email('Invalid email format.'),
  address: yup.string(),
});

const ModalEditCustomer = ({ show, setShow, customerId }) => {
  const allCustomer = useSelector(allCustomerInfos);
  const dispatch = useDispatch();
  const token = localStorage.getItem('token');

  const [validated, setValidated] = useState(false);
  const [file, setFile] = useState();

  const {
    register,
    setValue,
    getValues,
    clearErrors,
    handleSubmit,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(editCustomerSchema),
  });

  const handleClose = () => {
    clearErrors('name');
    clearErrors('phone');
    clearErrors('email');
    setValidated(false);
    setShow(false);
  };

  const customerInfo = allCustomer?.data.filter(
    (item) => item.id.id === customerId
  )[0];

  const onSubmit = () => {
    const name = getValues('name');
    const phone = getValues('phone');
    const email = getValues('email');
    const address = getValues('address');
    const tenantId = customerInfo.tenantId.id;
    dispatch(
      saveCustomersInfo({
        token,
        customerId,
        tenantId,
        name,
        phone,
        email,
        address,
        file,
      })
    );
    setValidated(false);
    setShow(false);
  };

  useEffect(() => {
    if (show && !errors.name && !errors.phone && !errors.email) {
      setValue('name', customerInfo?.name);
      setValue('phone', customerInfo?.phone);
      setValue('email', customerInfo?.email);
      setValue('address', customerInfo?.address);
      setFile(customerInfo.avatar?.value);
    }
    if (errors.name || errors.phone || errors.email) {
      setValidated(true);
    } else setValidated(false);
  }, [errors, show, setValue, customerInfo]);

  const onChangeFile = async (file) => {
    try {
      const image = await resizeFile(file);
      setFile(image);
    } catch (err) {
      toast.error(err);
    }
  };

  return (
    <Modal onHide={handleClose} show={show} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          {t('edit-customer')} {/*Chỉnh Sửa Khách Hàng*/}
        </Modal.Title>
      </Modal.Header>
      <Form noValidate validated={validated} onSubmit={handleSubmit(onSubmit)}>
        <Modal.Body>
          <Row>
            <Col sm="4">
              <Figure.Image
                height={300}
                width="100%"
                style={{ borderRadius: '10px', objectFit: 'scale-down' }}
                src={file ? file : defaultLogo}
                alt="logo"
              />
              <Form.Group className="position-relative mb-3">
                <Form.Label>{t('avatar') /*Ảnh Đại Diện */}</Form.Label>
                <Form.Control
                  type="file"
                  accept="image/*"
                  name={t('choose-file')}
                  title={t('no-file')}
                  onChange={(e) => onChangeFile(e.target.files[0])}
                />
              </Form.Group>
            </Col>
            <Col sm="8">
              <Form.Group as={Col} controlId="customerId">
                <Form.Label>ID :</Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Tên khách hàng"
                  value={customerId}
                  disabled
                />
              </Form.Group>
              <Form.Group as={Col} controlId="customerName">
                <Form.Label>
                  <span>
                    <i
                      className="fa fa-asterisk"
                      style={{ color: 'red', fontSize: '10px' }}
                      aria-hidden="true"
                    ></i>{' '}
                  </span>
                  {t('name')} :
                </Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder={t('customer-name')} //"Tên khách hàng"
                  {...register('name')}
                />
                {errors.name && (
                  <Alert
                    variant="danger"
                    style={{
                      padding: '5px',
                      height: '32px',
                      marginTop: '4px',
                    }}
                  >
                    <p>{errors.name.message}</p>
                  </Alert>
                )}
              </Form.Group>
              <Form.Group as={Col} controlId="phoneNumber">
                <Form.Label>
                  <span>
                    <i
                      className="fa fa-asterisk"
                      style={{ color: 'red', fontSize: '10px' }}
                      aria-hidden="true"
                    ></i>{' '}
                  </span>
                  {t('phone')}:
                </Form.Label>
                {/*Số Điện Thoại*/}
                <Form.Control
                  required
                  type="text"
                  placeholder={t('phone')} //"Số điện thoại"
                  {...register('phone')}
                />
                {errors.phone && (
                  <Alert
                    variant="danger"
                    style={{
                      padding: '5px',
                      height: '32px',
                      marginTop: '4px',
                    }}
                  >
                    <p>{errors.phone.message}</p>
                  </Alert>
                )}
              </Form.Group>
              <Form.Group as={Col} controlId="email">
                <Form.Label>
                  <span>
                    <i
                      className="fa fa-asterisk"
                      style={{ color: 'red', fontSize: '10px' }}
                      aria-hidden="true"
                    ></i>{' '}
                  </span>
                  Email:
                </Form.Label>
                <Form.Control
                  required
                  type="text"
                  placeholder="Email"
                  {...register('email')}
                />
                {errors.email && (
                  <Alert
                    variant="danger"
                    style={{
                      padding: '5px',
                      height: '32px',
                      marginTop: '4px',
                    }}
                  >
                    <p>{errors.email.message}</p>
                  </Alert>
                )}
              </Form.Group>
              <Form.Group as={Col} controlId="address">
                <Form.Label>{t('address')}</Form.Label>
                {/* địa chỉ */}
                <Form.Control
                  placeholder={t('address')} //"Địa chỉ"
                  as="textarea"
                  rows={3}
                  {...register('address')}
                />
                {errors.address && (
                  <Alert
                    variant="danger"
                    style={{
                      padding: '5px',
                      height: '32px',
                      marginTop: '4px',
                    }}
                  >
                    <p>{errors.address.message}</p>
                  </Alert>
                )}
              </Form.Group>
            </Col>
          </Row>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            {t('close')}
          </Button>
          <Button variant="primary" type="submit">
            {t('update')}
          </Button>
        </Modal.Footer>
      </Form>
    </Modal>
  );
};

export default ModalEditCustomer;
